export default "__VITE_ASSET__f$KDGx34__"